import API from "../global/api";

// PRA POS invoices. Deliberately separate from InvoicesAction.js — POS invoices
// go to PRA, not FBR, and share none of the FBR payload or response shape.

// Add POS Invoice
export const addPosInvoiceRequest = () => {
  return {
    type: "ADD_POS_INVOICE_REQUEST",
  };
};
export const addPosInvoiceSuccess = (data) => {
  return {
    type: "ADD_POS_INVOICE_SUCCESS",
    payload: data,
  };
};
export const addPosInvoiceError = (msg) => {
  return {
    type: "ADD_POS_INVOICE_ERROR",
    payload: msg,
  };
};
// `idempotencyKey` is the form's draft key (global/draftKey.js), sent with
// every Save of the draft - in the body, so it never depends on the server's
// CORS header list; `onSaved` lets the form start a new draft once the POS
// invoice is saved.
export const addPosInvoice = (
  data,
  resetForm,
  handleVisible,
  handleDangerVisible,
  { idempotencyKey, onSaved } = {},
) => {
  // The POS invoice exists - even when PRA rejected it or could not be
  // reached - so the form is emptied and the next Save is a new draft. Saving
  // the same form again used to file a second POS invoice.
  const saved = () => {
    if (onSaved) onSaved();
    if (resetForm) resetForm();
  };
  return (dispatch) => {
    dispatch(addPosInvoiceRequest());
    API.post(
      `/pos-invoice/add-pos-invoice`,
      idempotencyKey ? { ...data, idempotencyKey } : data,
    )
      .then((res) => {
        const result = res.data;
        dispatch(addPosInvoiceSuccess(result));

        // Code "100" is PRA's success code; anything else came back rejected.
        if (String(result?.praResponse?.Code) === "100") {
          handleVisible(
            `PRA INVOICE# ${result?.praResponse?.InvoiceNumber}`,
            result?.praResponse,
          );
        } else {
          handleDangerVisible(
            result?.praResponse?.Response ||
              result?.message ||
              "PRA rejected this POS invoice",
            result?.praResponse,
          );
        }
        saved();
      })
      .catch((error) => {
        const errData = error?.response?.data;
        const message =
          errData?.praResponse?.Response ||
          errData?.message ||
          error?.message ||
          "Failed to post POS invoice";
        dispatch(addPosInvoiceError(message));
        handleDangerVisible(message, errData?.praResponse);
        // Saved, then PRA failed or its token is missing.
        if (errData?.savedPosInvoice) saved();
      });
  };
};

// Getting POS Invoices List
export const getPosInvoicesRequest = () => {
  return {
    type: "POS_INVOICES_LIST_REQUEST",
  };
};
export const getPosInvoicesSuccess = (data) => {
  return {
    type: "POS_INVOICES_LIST_SUCCESS",
    payload: data,
  };
};
export const getPosInvoicesError = (msg) => {
  return {
    type: "POS_INVOICES_LIST_ERROR",
    payload: msg,
  };
};
export const getPosInvoices = (page, limit, searchTerm) => {
  return (dispatch) => {
    dispatch(getPosInvoicesRequest());
    API.get(
      `/pos-invoice/get-pos-invoices?page=${page}&limit=${limit}&search=${searchTerm}`,
    )
      .then((res) => {
        dispatch(getPosInvoicesSuccess(res.data));
      })
      .catch((error) => {
        dispatch(
          getPosInvoicesError(
            error?.response?.data?.message || "Failed to load POS invoices",
          ),
        );
      });
  };
};

// Getting Next POS Invoice Number
export const getPosInvoiceNumberRequest = () => {
  return {
    type: "POS_INVOICE_NUMBER_REQUEST",
  };
};
export const getPosInvoiceNumberSuccess = (data) => {
  return {
    type: "POS_INVOICE_NUMBER_SUCCESS",
    payload: data,
  };
};
export const getPosInvoiceNumberError = (msg) => {
  return {
    type: "POS_INVOICE_NUMBER_ERROR",
    payload: msg,
  };
};
export const getPosInvoiceNumber = (companyId, setFormData, companyShortName) => {
  return (dispatch) => {
    dispatch(getPosInvoiceNumberRequest());
    API.get(`/pos-invoice/get-last-pos-invoice/${companyId}`)
      .then((res) => {
        const result = res.data;
        dispatch(getPosInvoiceNumberSuccess(result));
        setFormData((prev) => ({
          ...prev,
          invoiceNumber: `${companyShortName}-${result.lastSequenceNumber}`,
        }));
      })
      .catch((error) => {
        dispatch(
          getPosInvoiceNumberError(
            error?.response?.data?.message || "Failed to get POS invoice number",
          ),
        );
      });
  };
};
